<template>
  <v-layout row wrap xs12>
    <v-flex md4 v-for="photo in photos" >
      <v-img v-bind:key="photo" :src="photo" aspect-ratio="1" class="grey lighten-2">
        <template v-slot:placeholder>
          <v-progress-circular
              indeterminate
              color="grey lighten-5"
          ></v-progress-circular>
        </template>
      </v-img>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Gallery",
  props: {
    photos: Array
  }
};
</script>

<style scoped>

</style>